<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">账户安全</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <ul>
                    <li class="item">
                        <span style="width: 100%;text-align:center;">账户信息</span>                      
                    </li>
                    <li class="item">
                        <span>手机号码</span>
                        <span @click="goChangePhone">{{ mobile }}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li class="item">
                        <span>登录密码</span>
                        <span @click="goSetPassword">{{pwdStatus ? "已设置" : "未设置"}}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem } from 'mint-ui';
import { accountSecurityAction } from '../../assets/js/api'

export default {
    name: 'zhanghuSafety',
  data() {
    return {  
        isFront:false, 
        isVip:false,
        haveRead:false,
        selected:'1',
        mobile: '',
        pwdStatus:false,
    };
  },
  mounted () {
    accountSecurityAction().then ( res => {
      if (res.s == 0) {
          this.mobile = res.mobile
          this.pwdStatus = (res.pwdStatus == 1) ? true : false
      }  
    }).catch ( err => {
        console.log(err)
    })
  },
  computed: {},
  components: {},
  methods: { 
      //跳转更换密码页面
      goChangePhone(){
          this.$router.push({ name:"changePhone", query: { mobile: this.mobile } });
      },
      //跳转设置密码页面
      goSetPassword(){
          if(!this.pwdStatus){
            this.$router.push({ name:"setPassword" });
          }else{
            this.$router.push({ name:"modifyPassword" })  
          }
          
      },
  },           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
i.el-icon-arrow-right{
    float: right;
    color: rgba(0, 0, 0,1);
    margin-top: 0.5rem;
    font-size: 0.55rem;
    margin-right: 0.6rem
}
.minContent{
    background-color: #fff;
    margin-top: 0.26rem;
}
.item{
    font-size: 0.42rem;
    color: rgba(0, 0, 0,0.7);
    line-height: 0.61rem;
    width: 94%;
    height: 0.97rem;
    margin-left: 0.61rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0,0.1);
    position: relative;
}
.item :nth-child(1){
    position: absolute;
    top: 0.2rem;
}
.item :nth-child(2){
    position: absolute;
    top: 0.2rem;
    right: 1.12rem;
}
.item :nth-child(3){
    position: absolute;
    top: -0.25rem;
    right: -0.2rem;
}
.minContent ul :first-child :nth-child(2){
    color: rgba(0, 0, 0,0.5);
    position: absolute;
    top: 0.2rem;
    right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/zhanghuSafety.vue